import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ServerService} from './ServerService';
import {EstadoRodizioLoja} from '../objeto/EstadoRodizioLoja';

export type SituacaoRodizio = 'ATIVO' | 'SEM_ACESSO' | 'SEM_PLANO' | 'CODIGO_TROCADO' | 'ENCERRADO';

@Injectable({
  providedIn: 'root'
})
export class RodizioLojaService extends ServerService {
  situacao: SituacaoRodizio = 'SEM_ACESSO';
  mensagem: string = null;
  rodadaEnviada: {codigo: any, horario: number} = null;
  // a mesma rodada reenviada (toque duplo, sinal ruim) usa a mesma chave: o servidor devolve a já gravada
  private chavePendente: string = null;

  constructor(http: HttpClient) {
    super(http);
  }

  async carreguePlanos(): Promise<any[]> {
    const planos = await this.obtenha('/comandas/rodizio/planos', {}).catch(() => []);
    EstadoRodizioLoja.definaPlanos(planos || []);
    return EstadoRodizioLoja.planos;
  }

  async atualize(): Promise<SituacaoRodizio> {
    const resposta: any = await this.obtenha('/comandas/rodizio/minha', {}).catch(() => null);
    if (!resposta) return this.situacao;

    this.situacao = resposta.situacao;
    this.mensagem = resposta.mensagem || null;
    EstadoRodizioLoja.definaRodizio(resposta.situacao === 'ATIVO' ? resposta.rodizio : null);
    return this.situacao;
  }

  /** Sem código: o servidor libera pelo QR da mesa quando ela tem um único rodízio lançado (SEM_PLANO se ainda não há). */
  async entre(hashMesa: string, codigo?: string): Promise<SituacaoRodizio> {
    const resposta: any = await this.facaPost('/comandas/rodizio/entrar', {hashMesa, codigo: codigo || null});
    this.situacao = resposta && resposta.situacao === 'SEM_PLANO' ? 'SEM_PLANO' : 'ATIVO';
    this.mensagem = null;
    EstadoRodizioLoja.definaRodizio(this.situacao === 'ATIVO' ? resposta.rodizio : null);
    return this.situacao;
  }

  /** Cliente ativa o rodízio na própria mesa: lança o plano na comanda da mesa e já entra. */
  /** idComanda: a comanda do cartão lida no celular (loja com cartão cliente); sem ela o servidor usa a aberta da mesa. */
  async ative(hashMesa: string, planoId: number, pessoas: number, idComanda: number = null): Promise<void> {
    const resposta: any = await this.facaPost('/comandas/rodizio/ativar', {hashMesa, planoId, pessoas, idComanda});
    this.situacao = 'ATIVO';
    this.mensagem = null;
    EstadoRodizioLoja.definaRodizio(resposta.rodizio);
  }

  async envieRodada(itens: any[]): Promise<any> {
    if (!this.chavePendente) this.chavePendente = this.gereChave();

    const resposta: any = await this.facaPost('/comandas/rodizio/rodada', {chave: this.chavePendente, itens});
    this.chavePendente = null;
    this.rodadaEnviada = {codigo: resposta.pedido && resposta.pedido.codigo, horario: Date.now()};
    EstadoRodizioLoja.definaRodizio(resposta.rodizio);
    return resposta;
  }

  /** Carrinho mudou depois de um erro: a próxima tentativa é outra rodada. */
  descarteChavePendente() {
    this.chavePendente = null;
  }

  async soliciteEncerramento(): Promise<void> {
    const resposta: any = await this.facaPost('/comandas/rodizio/solicitar-encerramento', {});
    EstadoRodizioLoja.definaRodizio(resposta.rodizio);
  }

  private gereChave(): string {
    const cripto: any = (window as any).crypto;
    if (cripto && typeof cripto.randomUUID === 'function') return cripto.randomUUID();

    return 'r' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12);
  }
}
